import { render, staticRenderFns } from "./speechCraft.vue?vue&type=template&id=0c3d7d16&scoped=true&"
import script from "./speechCraft.vue?vue&type=script&lang=js&"
export * from "./speechCraft.vue?vue&type=script&lang=js&"
import style0 from "./speechCraft.vue?vue&type=style&index=0&id=0c3d7d16&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3d7d16",
  null
  
)

export default component.exports